var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHippo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8 10.0312C86.4766 10.0078 82.5969 12.7781 78.8312 14.1906C76.5594 8.79219 71.2234 5 65 5C63.2375 5 61.5703 5.35937 60 5.91875V3.75C60 1.67812 58.3203 0 56.25 0H53.75C51.6797 0 50 1.67812 50 3.75V11.4031C44.6891 7.43438 37.6937 5 30 5C13.4312 5 0 16.1938 0 30V67.5C0 68.8812 1.11875 70 2.5 70H12.5C13.8813 70 15 68.8812 15 67.5V56.4391C20.0547 58.6828 26.05 60 32.5 60C38.95 60 44.9453 58.6828 50 56.4391V67.5C50 68.8812 51.1188 70 52.5 70H62.5C63.8812 70 65 68.8812 65 67.5V40H85V45C85 46.3812 86.1188 47.5 87.5 47.5H92.5C93.8812 47.5 95 46.3812 95 45V40C97.7609 40 100 37.7609 100 35V20.6219C100 15.2953 96.1266 10.0609 90.8 10.0312ZM70 22.5C68.6188 22.5 67.5 21.3813 67.5 20C67.5 18.6187 68.6188 17.5 70 17.5C71.3812 17.5 72.5 18.6187 72.5 20C72.5 21.3813 71.3812 22.5 70 22.5Z",
    fill: "#F26739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHippo);
export default __webpack_public_path__ + "static/media/hippo.36f83aa82aff9e35980137b67267eed9.svg";
export { ForwardRef as ReactComponent };